export const isAuthExpiredError = (error) => error?.message?.includes('유효하지 않은 토큰')
